import { StyleSheet, View } from "react-native";

import Text from "@components/CustomText";

import React from "react";
import color from "@constants/color";
import Rescheduled from "@assets/svg/RRD/rescheduled";

function RescheduleFooter({ footer }) {
  return (
    <View style={styles.footer}>
      <Rescheduled />
      <View style={{ marginLeft: 8 }}>
        <Text
          variant="body_text_4"
          style={{
            color: footer?.title_color,
          }}
        >
          {footer?.title}
        </Text>

        <Text
          variant="caption_2"
          style={{
            color: color.mediumBlacklightBlack,
          }}
        >
          {footer?.subtitle}
        </Text>
      </View>
    </View>
  );
}

export default RescheduleFooter;

const styles = StyleSheet.create({
  footer: {
    flexDirection: "row",
    paddingHorizontal: 16,
    alignItems: "flex-start",
    paddingVertical: 12,
  },
});
